import auth from './auth'
import guest from './guest'
import role from './role'

const rules = {
  auth,
  guest,
  role
}
export default rules
